module.exports = global["$"] = require("-!/home/pinchuk/hdd/dlt.loc/htdocs/gulp/node_modules/expose-loader/index.js?jQuery!/home/pinchuk/hdd/dlt.loc/htdocs/gulp/node_modules/source-map-loader/index.js!/home/pinchuk/hdd/dlt.loc/htdocs/gulp/node_modules/jquery/dist/jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/dist/jquery.js
 ** module id = 2
 ** module chunks = 0
 **/